"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultipleQueueTableDefaultSort = [{
        dataField: 'submissionTime',
        order: 'desc'
    }];
//# sourceMappingURL=MultipleQueueTableDefaultSort.js.map